<template>
  <LSButton v-if="section.type === 'clause'" variant="outline" type="danger" :size="size" @click="isOpen = true">
    <template #icon>
      <TrashIcon />
    </template>
  </LSButton>
  <RemoveClauseModal :section="section" :show="isOpen" @close="isOpen = false" @submit="removeClause" />
</template>

<script setup lang="ts">
import { ref } from 'vue'

import { useLegalDocumentStore } from '@/questionnaire/stores/legalDocument'
import { useQuestionnaireStore } from '@/questionnaire/stores/questionnaire'
import type { LegalDocumentSection } from '@/questionnaire/types'
import RemoveClauseModal from './RemoveClauseModal.vue'
import LSButton, { type ButtonSize } from '@/components/LSButton.vue'
import TrashIcon from '@/assets/icons/24/trash.svg?component'
import { updateDocument } from '@/services/documentsService'
import { errorNotification, successNotification } from '@/utils/notifications'

const props = defineProps<{
  section: LegalDocumentSection
  size: ButtonSize
}>()

const questionnaireStore = useQuestionnaireStore()
const legalDocumentStore = useLegalDocumentStore()

const isOpen = ref(false)

const removeClause = async () => {
  if (props.section.optional) {
    questionnaireStore.templateVariableValues[`section___${props.section.code}`] = false
  }
  const documentId = questionnaireStore.document.id as unknown as string
  const optional_sections = questionnaireStore.document.optional_sections as unknown as Array<string>
  const index = optional_sections.indexOf(props.section.code)
  optional_sections.splice(index, 1)
  const data = { optional_sections }
  await updateDocument(documentId, [], data)
    .then(() => {
      legalDocumentStore.remove(props.section.code)
      isOpen.value = false
      successNotification('successfully removed')
    })
    .catch(error => {
      errorNotification(error?.response?.data?.error)
    })
}
</script>
